// Money helpers. API returns paise as BigInt strings (see ecregi-api main.ts).
// All display values derive from those strings — never round-trip through Number
// for large amounts.

export function formatInr(rupees: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(rupees);
}

export function paiseToRupees(paise: string | number | bigint): number {
  if (typeof paise === 'bigint') return Number(paise) / 100;
  if (typeof paise === 'number') return paise / 100;
  return Number(paise) / 100;
}

export function formatPaise(paise: string | number | bigint): string {
  return formatInr(paiseToRupees(paise));
}

// Catalogue fees are stored and served as rupees (Decimal 2dp string) — e.g.
// "2500.00". This helper formats them without running through paise math.
export function formatRupees(rupees: string | number): string {
  const n = typeof rupees === 'number' ? rupees : Number(rupees);
  return formatInr(Number.isFinite(n) ? n : 0);
}

export function fullName(firstName: string | null, lastName: string | null): string {
  return [firstName, lastName].filter(Boolean).join(' ') || 'there';
}

export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}
